module.exports = "https://web-assets-production.autolist.com/_next/static/images/crossover-eb179ddaeff35144446bbd48150e6ec5.jpg";